<div class="card custom-box mb-3 border-0">
  <div class="card-body">
    <form #form="ngForm" class="form-validate" (ngSubmit)="search()">
      <div class="row mb-3">
        <label class="col-form-label col-auto">
          <i class="bi bi-search me-1"></i>ค้นหา
        </label>
      </div>
      <hr>
      <div class="row mb-3">
        <label for="zone" class="col-form-label col-xl-2">เขตพื้นที่</label>
        <div class="col-xl-6">
          <app-select-zone id="zone" [disabled]="isZone" name="zone" [(ngModel)]="params().zone"></app-select-zone>
        </div>
      </div>

      <div class="row mb-3">
        <label for="report-type" class="col-form-label col-xl-2">ประเภทรายงาน</label>
        <div class="col-xl-6">
          <select id="report-type" name="report-type" class="form-select" [(ngModel)]="params().arbitraryType">
            <option [ngValue]="undefined">เลือกทั้งหมด</option>
            <option value="OVER_HOUSE_NUMBER">1. รายงานการลงทะเบียนที่มีทะเบียนบ้านเลขที่เดียวกันเกิน 15 คน</option>
            <option value="IRREGULAR_SUM">2. รายงานการลงทะเบียนรายหน่วยบริการประจำที่มียอดผิดปกติ</option>
            <option value="OVER_ATTOR">3. รายงานสรุปข้อมูลการลงทะเบียนแทนกรณี รับมอบอำนาจมากกว่า 7 คน</option>
            <option value="TRANFER_UNIT">4. รายงานการลงทะเบียนเปลี่ยนหน่วยบริการจากสังกัดรัฐไปยังสังกัดเอกชน</option>
            <option value="IRREGULAR_TIME">5. รายงานการลงทะเบียนในช่วงเวลาที่ผิดปกติ</option>
          </select>
        </div>
      </div>

      <div class="row mb-3">
        <app-arbitrary-round [params]="params()"></app-arbitrary-round>
      </div>
      <div class="row mb-3">
        <div class="col-xl-6 text-center">
          <button type="submit" class="btn btn-primary me-3">
            <i class="bi bi-search me-1"></i>ค้นหา
          </button>
          <button type="button" id="btn-clear" (click)="reset()" class="btn btn-outline-secondary me-3">
            <i class="bi bi-eraser-fill me-2"></i>เคลียร์ข้อมูล
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="card custom-box mb-3 border-0">
  <div class="card-body">
    <div class="card-body">
      <div class="row mb-3">
        <div class="text-start col-4">
          <label class="col-form-label col-auto">
            <i class="bi bi-database me-2"></i>รายงานสรุปผลดำเนินงาน
          </label>
        </div>
        <div class="text-end col-8">
          <button type="button" id="btn-download" (click)="downloadSummary()" [disabled]="!dataBar?.length"
                  class="btn btn-success me-2">
            <i class="bi bi-file-excel"></i> สรุปผลการดำเนินงานแยกตามสถานะ
          </button>
          <button type="button" id="btn-navigate" (click)="navigate()"
                  class="btn btn-primary me-2">
            <i class="bi bi-file-text"></i> ดูรายงานผลการตรวจสอบข้อมูลการลงทะเบียนพลการ
          </button>
        </div>
      </div>
      <hr>
      <div class="row mb-3" style="height: 500px">
        <ngx-charts-pie-chart id="pie-chart"
          [view]="view"
          [results]="dataPie"
          [scheme]="colorPie"
          [gradient]="false"
          [legend]="true"
          [labels]="true"
          [trimLabels]="false"
          legendTitle="สถานะ"
          [doughnut]="false"
          (select)="onSelect($event)"
          (activate)="onActivate($event)"
          (deactivate)="onDeactivate($event)">
        </ngx-charts-pie-chart>
      </div>
      <div class="row mb-3" style="height: 500px">
        <ngx-charts-bar-vertical id="bar-vertical"
          [view]="view"
          [scheme]="colorBar"
          [results]="dataBar"
          [gradient]="false"
          [xAxis]="true"
          [yAxis]="true"
          [legend]="true"
          [trimXAxisTicks]="false"
          [trimYAxisTicks]="false"
          [showXAxisLabel]="true"
          [showYAxisLabel]="true"
          legendTitle="สถานะ"
          xAxisLabel="สถานะ"
          yAxisLabel="จำนวน"
          (select)="onSelect($event)">
        </ngx-charts-bar-vertical>
      </div>
    </div>
  </div>
</div>
